export const TOGGLE_BUSY = 'TOGGLE_BUSY';
export const FIRESTORE_OPTIMISTIC_UPDATE = 'OPTIMISTIC:UPDATE';
export const FIRESTORE_OPTIMISTIC_REVERT = 'OPTIMISTIC:REVERT';